import { render, staticRenderFns } from "./EatOrYeetPrivacy.vue?vue&type=template&id=93f7b91a&scoped=true"
import script from "./EatOrYeetPrivacy.vue?vue&type=script&lang=js"
export * from "./EatOrYeetPrivacy.vue?vue&type=script&lang=js"
import style0 from "./EatOrYeetPrivacy.vue?vue&type=style&index=0&id=93f7b91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f7b91a",
  null
  
)

export default component.exports